import React from 'react';
import { TextInput } from 'react-native-paper';

export type ProductUnitAffixKind = 'price' | 'stock';

export const getProductUnitAffixText = ({
  priceType,
  unitOfMass,
  kind,
}: {
  priceType: string;
  unitOfMass?: string;
  kind: ProductUnitAffixKind;
}): string | null => {
  const unit = String(unitOfMass || '').trim();
  if (priceType !== 'unit' || !unit) return null;

  return kind === 'price' ? `/${unit}` : unit;
};

const ProductUnitAffix = (props: {
  priceType: string;
  unitOfMass?: string;
  kind: ProductUnitAffixKind;
}): React.ReactNode | undefined => {
  const text = getProductUnitAffixText(props);
  return text ? <TextInput.Affix text={text} /> : undefined;
};

export default ProductUnitAffix;
